export function createWorkforceIdentityClient(transport) {
    return {
        /**
         * Register tenant OIDC metadata
         *
         * Requires scope: workforce:federation:write
         */
        postTenantsOidcProviders(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/oidc-providers`,
                body,
                options,
            });
        },
        /**
         * Link an opaque external subject
         *
         * Requires scope: workforce:subject:link
         */
        postTenantsOidcProvidersSubjectLinks(tenantId, providerId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/oidc-providers/${encodeURIComponent(providerId)}/subject-links`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
        /**
         * Replace a tenant's OIDC provider registration
         *
         * Requires scope: workforce:federation:write
         */
        updateOidcProvider(tenantId, providerId, body, options) {
            return transport.request({
                method: "PUT",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/oidc-providers/${encodeURIComponent(providerId)}`,
                body,
                options,
            });
        },
        /**
         * Resolve a federated subject to its platform subject
         *
         * Requires scope: workforce:subject:resolve
         */
        resolveSubjectLink(tenantId, providerId, externalSubject, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/oidc-providers/${encodeURIComponent(providerId)}/subject-links/${encodeURIComponent(externalSubject)}`,
                options,
            });
        },
        /**
         * One page of a tenant's staff, newest first
         *
         * Requires scope: workforce:member:read
         */
        listWorkforceMembers(tenantId, limit, after, merchantId, locationId, status, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/workforce-members`,
                query: {
                    limit: limit,
                    after: after,
                    merchantId: merchantId,
                    locationId: locationId,
                    status: status,
                },
                options,
            });
        },
        /**
         * Record a person a tenant employs, before they have signed in
         *
         * Requires scope: workforce:member:write
         */
        inviteWorkforceMember(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/workforce-members`,
                body,
                options,
            });
        },
        /**
         * One staff member
         *
         * Requires scope: workforce:member:read
         */
        getWorkforceMember(tenantId, memberId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/workforce-members/${encodeURIComponent(memberId)}`,
                options,
            });
        },
        /**
         * Activate or suspend a staff member
         *
         * Requires scope: workforce:member:write
         */
        commandWorkforceMember(tenantId, memberId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/workforce-members/${encodeURIComponent(memberId)}/commands`,
                body,
                options,
            });
        },
    };
}
//# sourceMappingURL=workforce-identity.js.map